export default __webpack_public_path__ + "static/gluten-free-6e054834857321299c5add2542485edb.svg";